import { LatLngExpression } from "leaflet";
import { defineMessages, useIntl } from "react-intl";
import { articleTypes, form, routes } from "../i18n/sharable-defs";
import { Wrapper } from "../components/layout/wrapper";
import SpriteSvg from "../components/common/svg";
import { Facebook, Instagram } from "../components/common/icones";
import { MapContainer, MapHomeMarker } from "../bundles/map";
import ContactForm from "../components/contact-form";

import "./contact.scss";
import { useAppConfig } from "@ct-react/core";
import { ArticleType } from "@shared/url";
import SeoMetas from "../components/layout/seo-metas";

const transDefs = defineMessages({
  click_numbers: { id: "contact.click-numbers", defaultMessage: "Cliquez sur les numéros pour nous appeler ou utilisez WhatsApp pour discuter." },
  schedule: { id: "contact.schedule", defaultMessage: "Horaires" },
  schedule_winter: { id: "contact.schedule-winter", defaultMessage: "<s>Hiver | </s> Lundi à Samedi" },
  schedule_summer: { id: "contact.schedule-summer", defaultMessage: "<s>Été | </s> Lundi à Vendredi" },
});

const Contact = () => {

  const intl = useIntl();
  const { options: { mapToken } } = useAppConfig();
  const position = [ 46.31276174491367, 7.483991126029801 ] as LatLngExpression;

  return(
    <Wrapper.Centered className="contact">
      <SeoMetas title={intl.formatMessage(routes.contact)} />
      <h1>{intl.formatMessage(routes.contact)}</h1>
      <div>
        <div className="info">
          <p><em>{intl.formatMessage(transDefs.click_numbers)}</em></p>
          <div>
            <a href="https://wa.me/41794876948" target="_blank">
            <SpriteSvg id="whatsapp" className="wa" />
            </a>
            <a href="tel:0794876948" aria-label="Appelez-nous" target="_blank">{intl.formatMessage(form.booking)} : +41 79 487 69 48</a>
          </div>

          <div>
            <a href="https://wa.me/41799168260" target="_blank">
              <SpriteSvg id="whatsapp" className="wa" />
            </a>
            <a href="tel:0799168260" aria-label="Appelez-nous" target="_blank">{intl.formatMessage(form.inResort)} : +41 79 916 82 60</a>
          </div>

          <div>
            <a href="https://wa.me/41794509704" target="_blank">
              <SpriteSvg id="whatsapp" className="wa" />
            </a>
            <a href="tel:0794509704" aria-label="Appelez-nous" target="_blank">{intl.formatMessage(articleTypes[ArticleType.SALE])} : +41 79 450 97 04</a>
          </div>

          <div>
            <SpriteSvg id="mail-line"/>
            <a href="mailto:info@verbierrentals.com" aria-label="Envoyez nous un email">
              info@verbierrentals.com
            </a>
          </div>

          <address>
            <h3>{intl.formatMessage(form.address)}</h3>
            <a href="https://www.google.com/maps/place/Verbier+Rentals+S%C3%A0rl/@46.095235,7.2233403,17z/data=!3m1!4b1!4m6!3m5!1s0x478ece3357a5ef7b:0x27632d4a9acffc6c!8m2!3d46.0952314!4d7.2282112!16s%2Fg%2F1th1bmnt?entry=ttu&g_ep=EgoyMDI2MDQyNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" aria-label="Retrouvez-nous à Verbier">
              Verbier Rentals Sàrl<br/>
              Chemin des Vernes 5A<br/>
              CH-1936 Verbier
            </a>
            <h3>{intl.formatMessage(transDefs.schedule)}</h3>
            <p>{intl.formatMessage(transDefs.schedule_winter,{
              s: (chunks) => <strong key="winter">{chunks}</strong>
            })}<br/>
            09:00 - 18:00</p>
            <p>{intl.formatMessage(transDefs.schedule_summer,{
              s: (chunks) => <strong key="summer">{chunks}</strong>
            })}<br/>
            09:00 - 12:30 / 14:00 - 17:00</p>
          </address>

          <div className="social-icones">
              <Facebook className="outline"/>
              <Instagram className="outline"/>
          </div>
        </div>

        <div className="form">
          <ContactForm />
        </div>

        <MapContainer mapboxToken={mapToken} center={position} zoom={17}>
          <MapHomeMarker position={position} />
        </MapContainer>
      </div>

    </Wrapper.Centered>
  );
};

export default Contact;
